import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import Button from '@strava/ui/Button';
import Spinner from '@strava/ui/Spinner';

import styles from './index.scss';

class PromoCodeInput extends React.Component {
  state = {
    promoCode: ''
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { promoCode } = this.state;
    const { handlePostCheckPromoCode } = this.props;

    handlePostCheckPromoCode(promoCode);
  };

  promoCodeInputClassName = () => {
    const { hasError } = this.props;

    return `${styles.promoCodeInput} form-group ${hasError ? 'has-error' : ''}`;
  };

  renderBtnContent = () => {
    const { isSubmitting } = this.props;

    if (isSubmitting) {
      return <Spinner />;
    }

    return I18n.t(
      'strava.subscriptions.checkout.summary.organic.promo_code.cta.apply'
    );
  };

  render() {
    const { promoCode } = this.state;
    const { disabled, hasError } = this.props;

    return (
      <div className={styles.promoCodeContainer}>
        <form className={styles.form} onSubmit={this.handleSubmit}>
          <div className={this.promoCodeInputClassName()}>
            <label htmlFor="promo-code" className="sr-only">
              {I18n.t(
                'strava.subscriptions.checkout.summary.organic.promo_code.label'
              )}
            </label>
            <input
              id="promo-code"
              className="form-control"
              type="text"
              autoComplete="off"
              autoFocus={true}
              disabled={disabled}
              value={promoCode}
              onChange={(e) => this.setState({ promoCode: e.target.value })}
            />
            <Button
              type="submit"
              variant="default"
              className={styles.btnApply}
              disabled={disabled}
            >
              {this.renderBtnContent()}
            </Button>
          </div>
        </form>
        {hasError && (
          <div className={styles.errorMessage}>
            {I18n.t(
              'strava.subscriptions.checkout.summary.organic.promo_code.error'
            )}
          </div>
        )}
      </div>
    );
  }
}

PromoCodeInput.propTypes = {
  handlePostCheckPromoCode: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool
};

PromoCodeInput.defaultProps = {
  isSubmitting: false,
  disabled: false,
  hasError: false
};

export default PromoCodeInput;
